import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function SellCTA() {
  return <section className="w-full bg-brand-card border-t-4 border-t-brand-orange" aria-labelledby="sell-heading" data-id="element-240">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-241">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left" data-id="element-242">
          <div data-id="element-243">
            <h2 id="sell-heading" className="font-oswald font-bold text-[28px] sm:text-3xl md:text-4xl uppercase tracking-wide text-white mb-2" data-id="element-244">
              Looking to Sell Your Equipment?
            </h2>
            <p className="text-brand-muted text-base md:text-lg" data-id="element-245">
              We buy used construction equipment. Get a fair cash offer — fast
              and hassle-free.
            </p>
          </div>
          <a href="#contact" className="inline-flex items-center gap-2 px-8 py-4 bg-brand-orange text-white font-oswald font-semibold text-base uppercase tracking-wider rounded-md hover:bg-brand-orange/90 transition-colors duration-200 min-h-[48px] flex-shrink-0" data-id="element-246">
            Get Your Offer
            <ArrowRightIcon className="w-5 h-5" aria-hidden="true" data-id="element-247" />
          </a>
        </div>
      </div>
    </section>;
}